import { ISignUpManager } from 'views/public/SignUp/useSignUpManager';
import { useSignUpContext, SignUpStage } from 'views/public/SignUp/SignUpContext';
import EmailVerificationPage from 'views/public/SignUp/EmailVerificationPage/EmailVerificationPage';
import ManualSignupForm from './ManualSignupForm';
import SignupForm from './SignupForm';

export interface ISignupOverlayProps {
    displayManualSignUp: boolean;
    setDisplayManualSignUp: (display: boolean) => void;
    signUpManager: ISignUpManager;
}

const SignupOverlay = ({ displayManualSignUp, setDisplayManualSignUp, signUpManager }: ISignupOverlayProps) => {
    const { currentStage, setCurrentStage } = useSignUpContext();

    const handleBackFromVerification = () => {
        setCurrentStage(SignUpStage.PRO_FORMA_QUICK_START);
        setDisplayManualSignUp(false);
    };

    const renderContent = () => {
        // Show EmailVerificationPage for both EMAIL_VERIFICATION and ACCOUNT_CREATED stages
        // ACCOUNT_CREATED is set for overlay flow to allow /account_created page access after password reset
        if (!signUpManager.socialSignUpConnectionType
            && (currentStage === SignUpStage.EMAIL_VERIFICATION || currentStage === SignUpStage.ACCOUNT_CREATED)
        ) {
            return (
                <EmailVerificationPage
                    onBack={handleBackFromVerification}
                    email={signUpManager.email.value}
                    isOverlay
                />
            );
        }

        if (displayManualSignUp) {
            return (
                <ManualSignupForm
                    signUpManager={signUpManager}
                    onClickBack={() => setDisplayManualSignUp(false)}
                    userOrgLookupData={signUpManager.userOrgLookupData}
                />
            );
        }

        return (
            <SignupForm
                signUpManager={signUpManager}
                showManualSignUpForm={() => setDisplayManualSignUp(true)}
            />
        );
    };

    return (
        <div className="ProForma__overlay">
            <div className="d-flex justify-content-center h-100 mt-sm-3 mt-md-5">
                {renderContent()}
            </div>
        </div>
    );
};

export default SignupOverlay;
